import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { BasedataService } from '../../shared/basedata.service';
import { BimModel } from './bim-model.interface';

import { CreateBimModelDto } from './bim-model.dto';
import { BpConfigService } from '../../config/bp-config.service';


@Injectable({providedIn: 'root'})
export class BimModelApiService extends BasedataService {

  endpoint: string;

  constructor(private http: HttpClient, configService: BpConfigService) {
    super(configService);
    this.endpoint = super.getFullUrl('bim-models');
  }

  getBimModels(): Observable<BimModel[]> {
    return this.http
      .get<BimModel[]>(this.endpoint);
  }

  getBimModelById(id: string): Observable<BimModel> {
    return this.http.get<BimModel>(this.endpoint + `/${id}`);
  }

  createBimModel(bimModel: CreateBimModelDto): Observable<BimModel> {
    return this.http
      .post<BimModel>(this.endpoint, bimModel);
  }

  updateBimModel(id: string, dto: any) {
    return this.http
        .patch<BimModel>(this.endpoint + "/" + id, dto);
  }

  deleteBimModel(item: any): Observable<BimModel>  {
    return this.http
          .delete<BimModel>(this.endpoint + "/" + item.id)
          .pipe(
            catchError(e => {
              throw new HttpErrorResponse(e)
            })
          )
  }


}
